import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../BaseComponent';
import { SearchSelect } from '../SearchSelectComponent';
import { Edit } from '../Icon';
import { IconRightDecorator } from '../Icon/IconRightDecorator';
import { Input } from '../Input';
import { FormField } from '../FormFields';
import { Button } from '../Buttons';
import { HBox } from '../Box';
import ButtonComponent from '../../containers/App/Components/Button/Button';
import styles from './EditableSearchSelect.module.css';

const STATE = {
  editMode: false,
  description: '',
};

class EditableSearchSelectComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  toggleEdit() {
    if (!this.props?.value?.label) return;
    this.setState(prev => ({ ...prev, editMode: !prev.editMode, description: this.props.value.label }));
  }

  onInputChange(evt) {
    evt.value = evt.target.value;
    this.setState({ description: evt.value });
    evt.editedValue = evt.value;
    this.props.onEdit(evt);
  }

  render() {
    return (
      <>
        {!this.state.editMode && (
          <SearchSelect
            className={styles.searchSelect}
            options={this.props.options}
            placeholder={this.props.placeholder}
            value={this.props.value}
            onChange={this.props.onChange}
          />
        )}
        {this.state.editMode && (
          <HBox vCenter>
            <FormField>
              <input
                // large
                className="form-control"
                name="description"
                value={this.state.description ?? ''}
                onChange={this.onInputChange.bind(this)}
                rightDecoration={
                  <ButtonComponent style={'ButtonSoftEdit'} size={'btn-sm'} onClick={this.toggleEdit.bind(this)}>
                    <Edit />
                  </ButtonComponent>
                }
              />
            </FormField>
          </HBox>
        )}
        {!this.props.editMode && (
          <div>
            <ButtonComponent style={'ButtonSoftEdit'} size={'btn-sm'} onClick={this.toggleEdit.bind(this)}>
              <Edit />
            </ButtonComponent>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {};
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const EditableSearchSelect = compose(withConnect, withRouter, injectIntl)(EditableSearchSelectComp);
